import { useContext } from 'react';
import UserContext from '../contexes/UserContext';

export enum UserLevel {
  MASTER = 'master',
  ADMIN = 'admin',
  EDITOR = 'editor',
  BASIC = 'basic',
}

const levelRankMap: Record<UserLevel, number> = {
  [UserLevel.MASTER]: 4,
  [UserLevel.ADMIN]: 3,
  [UserLevel.EDITOR]: 2,
  [UserLevel.BASIC]: 1,
};

// Vastaa backendin levelRank-logiikkaa: tuntematon tai puuttuva taso (esim.
// consumerin null) saa arvon 0, jolloin se ei läpäise mitään tasovaatimusta.
export const levelRank = (level?: string | null): number => {
  if (!level) return 0;
  return levelRankMap[level as UserLevel] ?? 0;
};

export const hasRequiredLevel = (
  level: string | null | undefined,
  requiredLevel: UserLevel
): boolean => levelRank(level) >= levelRank(requiredLevel);

export interface UseCanResult {
  level: string | null | undefined;
  isMaster: boolean;
  canManageUsers: boolean;
  canEditContent: boolean;
  isReadOnly: boolean;
  hasServiceCallAccess: boolean;
}

export const useCan = (): UseCanResult => {
  const [user] = useContext(UserContext);
  const level = user?.level;

  return {
    level,
    isMaster: level === UserLevel.MASTER,
    canManageUsers: hasRequiredLevel(level, UserLevel.ADMIN),
    canEditContent: hasRequiredLevel(level, UserLevel.EDITOR),
    isReadOnly: level === UserLevel.BASIC,
    hasServiceCallAccess: user?.partner?.hasServiceCallAccess === true,
  };
};
